
import { PaginacionProps } from "../global/PaginacionInterface";
import { defaultExhortoRecibido, ExhortoRecibidoProps } from "../recepcion/ExhortoRecibidoInterface";
import { defaultExpediente, ExpedienteProps } from "../recepcion/ExpedienteInterface";

export const defaultBuscarLibroExhortosLibradosResponse: BuscarLibroExhortosLibradosResponse = { currentPageIndex: 0, pageCount: 0, recordCount: 0, records: [], };

export const defaultBuscarLibroExhortosLibrados: BuscarLibroExhortosLibrados = { idAutoridad: 0, numeroReferencia: '', idTipoConsecutivo: 0 };

export const defaultLibroExhortosLibrados: LibroExhortosLibradosProps = { 
    idLibroExhortoLibrado:      0,
    idExhortoLibrado:           0,
    numeroExhorto:              '',
    numeroReferencia:           '',
    autoridadRequerida:         '',
    claseExhorto:               '',
    objetoExhorto:              '', 
    observaciones:              '',   
    documento:                  '', 
    expediente:                 defaultExpediente,
    exhortoRecibido:            defaultExhortoRecibido,
    esExhortoRecibido:          false,
};


export interface LibroExhortosLibradosProps {
    idLibroExhortoLibrado:      number;
    idExhortoLibrado:           number;
    numeroExhorto:              string;
    numeroReferencia:           string;
    autoridadRequerida:         string;
    claseExhorto:               string; 
    objetoExhorto:              string;
    observaciones:              string;
    expediente:                 ExpedienteProps;
    exhortoRecibido:            ExhortoRecibidoProps;
    esExhortoRecibido:          boolean;
    documento:                  string;
    fecha?:                     Date;
    fechaAcuerdo?:              Date;
    fechaEnvio?:                Date;
}

export interface BuscarLibroExhortosLibrados {
    idAutoridad:                number;
    numeroReferencia:           string;
    idTipoConsecutivo?:         number;
}

export interface BuscarLibroExhortosLibradosParams extends PaginacionProps, BuscarLibroExhortosLibrados { }

export interface BuscarLibroExhortosLibradosResponse {
    currentPageIndex:           number;
    pageCount:                  number;
    recordCount:                number;
    records:                    LibroExhortosLibradosProps[];
}

export interface GuardarObservaciones {
    id:                         number;
    observaciones:              string;
}

export interface DescargarInformacionParams { 
    idAutoridad:                number;
    numeroReferencia:           string;
    idTipoConsecutivo?:         number;
}